import React, { useState, useCallback, useEffect, useRef } from "react";

import { Drawer } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import DrawPitch from "../../components/DrawPitch";
import { MainContainer } from "../../components/Contents/Contents.element";
import MatchTrack from "../../components/MatchTrack";
import MatchSelection from "../../components/MatchSelection";
import Players from "../../components/PlayerDrawer";
import EventTrack from "../../components/EventTrack";
import PitchOptions from "../../components/PitchOptions";

import GeneralReportIcon from "../../assets/icons/GeneralReportIcon.png";
import DisplayPlayer from "../../assets/icons/DisplayPlayer.png";
import ContourIcon from "../../assets/icons/ContourIcon.png";
import PassingAttackIcon from "../../assets/icons/ArrowIcon.png";
import VoronoiIcon from "../../assets/icons/GridIcon.png";
import PitchIcon from "../../assets/icons/PitchIcon.png";
import Pitch from "../../assets/icons/Pitch.png";
import PassingNetworkIcon from "../../assets/icons/PassingNetwork.png";
import perspective from "../../assets/icons/perspective.png";
import RiskMapIcon from "../../assets/icons/RiskMap.png";
import PassingAttack from "../../assets/icons/PassingAttack.png";
import DefensiveHullIcon from "../../assets/icons/DefensiveHull.png";

import { postData, fetchData } from "../../services/api";
import apiUrls from "../../config/apiUrls";
import { useLoading } from "../../contexts/LoadingContext";
import { useTheme } from "../../contexts/ThemeContext";

import CustomButton from "../../ui/Button";
import CustomIconButton from "../../ui/IconButton";
import SelectDropdown from "../../ui/SelectDropdown";
import MessagePopup from "../../ui/MessagePopup";
import LoadingSpinner from "../../ui/LoadingSpinner";
import Switch from "../../ui/CustomSwitch";
import "./style.css";
import ApiResponse from "../../types/IApiResponse";
import { IPlayerForVoronoi } from "../../types/IVoronoiData";
import IFilterOptions from "../../types/IFilterOptions";
import LastMatchdata from "../../types/ILastMatchdata";
import { IPassingNetworkData } from "../../types/IPassingNetworkData";
import IDefensiveHullData, {
  IAveragePositionData,
  IEventsPositionData,
} from "../../types/IDefensiveHullData";
import Slider, { SliderThumb } from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import handleApiResponse from "../../utils/handleApiResponse";
import HullSelectDropdown from "../../ui/HullSelectDropdown";
// import MatchTrackD3 from "../../components/MatchTrackd3";

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
};

const CustomSlider = styled(Slider)(({ theme }) => ({
  color: "#3a8589",
  height: 3,
  padding: "13px 0",
  "& .MuiSlider-thumb": {
    height: 13,
    width: 13,
    backgroundColor: "#fff",
    border: "2px solid #DADADA",
    pointerEvents: "none",
    borderRadius: "5px",
    "& .thumb-bars": {
      height: 5,
      width: 1,
      backgroundColor: "black",
      marginLeft: 1,
      marginRight: 1,
    },
  },
  "& .MuiSlider-track": {
    height: 10,
    backgroundColor: "#00D1A8",
    border: "1px solid #00D1A8",
  },
  "& .MuiSlider-rail": {
    color: theme.palette.mode === "dark" ? "#bfbfbf" : "white",
    opacity: theme.palette.mode === "dark" ? undefined : 1,
    height: 10,
    borderRadius: "3px",
  },
}));

function ThumbComponent(props: any) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      {/* <span className="thumb-bars" /> */}
      {/* <span className="thumb-bars" /> */}
    </SliderThumb>
  );
}

const Home: React.FC<{ toggle: boolean; isSubSidebarOpen: boolean }> = (
  props
) => {
  const { loading, startLoading, stopLoading } = useLoading();
  const { theme } = useTheme();
  const [homeTeamName, setHomeTeamName] = useState<string>("");
  const [awayTeamName, setAwayTeamName] = useState<string>("");
  const [playedTeam, setPlayedTeam] = useState<string>("");
  const [homeTeamScore, setHomeTeamScore] = useState<number>(0);
  const [awayTeamScore, setAwayTeamScore] = useState<number>(0);
  const [matchDate, setMatchDate] = useState<string>("");
  const [matchList, setMatchList] = useState<any[]>([]);
  const [selectedMatchId, setSelectedMatchId] = useState<number>(0);
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [playerSidebarOpen, setPlayerSidebarOpen] = useState<boolean>(false);
  const [isPlayerSwitchToggled, setIsPlayerSwitchToggled] =
    useState<boolean>(false);
  const [passNetworkPlayers, setPassNetworkPlayers] = useState<any[]>([]);
  const [avgPositionPlayers, setAvgPositionPlayers] = useState<
    IPlayerForVoronoi[]
  >([]);
  const [passNetworkPlayerPasses, setPassNetworkPlayerPasses] = useState<any[]>(
    []
  );
  const [eventData, setEventData] = useState<any[]>([]);
  const [playerData, setPlayerData] = useState<any[]>([]);
  const [playerAttackPassData, setPlayerAttackPassData] = useState<any[]>([]);
  const [riskMapData, setRiskMapData] = useState<any[]>([]);
  const [matchEndTime, setMatchEndTime] = useState<number>(0);
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const [popupMessage, setPopupMessage] = useState<string>("");
  const [selectedFilters, setSelectedFilters] = useState<IFilterOptions>({
    homeTeam: "",
    matchLabel: "1",
    matchStatus: "1",
    selectedOption: "LAST MATCH",
    isDisplayPlayer: false,
    isShowHeatMap: false,
    isDisplayPassingNetwork: false,
    isVoronoiOfPlayers: false,
    selectedPlayerIdLeft: "",
    selectedPlayerIdRight: "",
    selectedOppositionTeamId: "All",
    showPitchOptions: false,
    isModalOpen: false,
    isSelectFinalThird: false,
    selectedPitchOption: "WholePitch",
    isPlayerViewToggled: false,
    competitionId: 0,
    seasonId: 0,
    selectedSeason: " ",
    isShowRiskMap: false,
    isShowDefensiveHull: false,
  });
  const [groupIndex, setGroupIndex] = useState<number>(0);
  const [displayedMatches, setDisplayedMatches] = useState<any[]>([]);
  const [hullPlayers, setHullPlayers] = useState<
  { value: number; label: string }[]
  >([]);
  const [firstHullPlayer, setFirstHullPlayer] = useState(0);
  const [secondHullPlayer, setSecondHullPlayer] = useState(0);
  const [hoverMatchId, setHoverMatchId] = useState(0);
  const [selectedMatches, setSelectedMatches] = useState([]);
  const [playerCoordinates, setPlayerCoordinates] = useState<
    IEventsPositionData[]
  >([]);
  const [secondPlayerCoordinates, setSecondPlayerCoordinates] = useState<
    IEventsPositionData[]
  >([]);
  const [innerCoordinates, setInnerCoordinates] = useState<
    IEventsPositionData[]
  >([]);
  const [secondInnerCoordinates, setSecondInnerCoordinates] = useState<
    IEventsPositionData[]
  >([]);
  const [playerAvgPosition, setPlayerAvgPosition] =
    useState<IAveragePositionData>({
      location_X: 0,
      location_Y: 0,
    });
  const [secondPlayerAvgPosition, setSecondPlayerAvgPosition] =
    useState<IAveragePositionData>({
      location_X: 0,
      location_Y: 0,
    });
  const [firstPlayerName, setFirstPlayerName] = useState("");
  const [secondPlayerName, setSecondPlayerName] = useState("");
  const minDistance = 1;
  const [value, setValue] = useState([0, matchList?.length || 2]);
  const handleChange = (
    event: Event,
    newValue: number | number[],
    activeThumb: number
  ) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    if (activeThumb === 0) {
      setValue([Math.min(newValue[0], value[1] - minDistance), value[1]]);
    } else {
      setValue([value[0], Math.max(newValue[1], value[0] + minDistance)]);
    }
  };
  useEffect(() => {
    const filteredMatches = matchList
      .slice(value[0], value[1] + 1)
      // @ts-ignore
      .map((match) => match.matchId);
    // @ts-ignore
    setSelectedMatches(filteredMatches);
  }, [value]);

  useEffect(() => {
    const getData = setTimeout(async () => {
      startLoading();
      if (selectedFilters.isShowDefensiveHull) {
        await fetchPlayersList();
        await fetchPlayerCoordinates();
        await fetchSecondPlayerCoordinates();
      }
      stopLoading();
    }, 1000);
    return () => clearTimeout(getData);
  }, [selectedMatches, selectedFilters.isShowDefensiveHull]);

  useEffect(() => {
    const getData = setTimeout(async () => {
      startLoading();
      await fetchPlayerCoordinates();
      stopLoading();
    }, 1000);
    return () => clearTimeout(getData);
  }, [firstHullPlayer]);

  useEffect(() => {
    const getData = setTimeout(async () => {
      startLoading();
      await fetchSecondPlayerCoordinates();
      stopLoading();
    }, 1000);
    return () => clearTimeout(getData);
  }, [secondHullPlayer]);

  useEffect(() => {
    const reversedMatches = matchList.slice().reverse(); // Reverse the order of matches
    const initialMatches = reversedMatches.slice(
      groupIndex * 3,
      (groupIndex + 1) * 3
    );
    setDisplayedMatches(initialMatches.reverse());
  }, [groupIndex, matchList]);

  useEffect(() => {
    // Reset group index to 0 when match data changes
    setGroupIndex(0);
  }, [matchList]);

  const handleNextGroup = () => {
    setGroupIndex(
      Math.min(groupIndex + 1, Math.ceil(matchList.length / 3) - 1)
    );
  };

  const handlePreviousGroup = () => {
    setGroupIndex(Math.max(groupIndex - 1, 0));
  };

  const previousFinalThirdValue = useRef(selectedFilters.isSelectFinalThird);

  const renderMessagePopup = () =>
    openPopup && (
      <MessagePopup
        message={popupMessage}
        onClose={() => setOpenPopup(false)}
      />
    );

  const handleSelectedMatchId = (matchId: number) => {
    setSelectedMatchId(matchId);
  };
  const handleCloseModal = (selectedOption: string) => {
    handleFilterChange(
      "isSelectFinalThird",
      selectedOption === "FinalThird" ? true : false
    );
    handleFilterChange("selectedPitchOption", selectedOption);
    handleFilterChange("isModalOpen", false);
  };

  const handleFilterChange = useCallback(
    (filterType: string, value: string | boolean) => {
      setSelectedFilters((prevFilters) => ({
        ...prevFilters,
        [filterType]: value,
      }));
    },
    []
  );

  const fetchPlayersList = async () => {
    if (selectedMatches.length > 0) {
      try {
        startLoading();
        const response = await fetch(
          `${apiUrls["GetPlayersByTeamMatchForHull"]}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": "e68b43bc-d581-4def-9231-d25c019fb16e",
            },
            body: JSON.stringify({
              teamId: selectedFilters.homeTeam,
              listMatchId: selectedMatches,
            }),
          }
        );
        const data = await response.json();
        setHullPlayers(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };
  const fetchPlayerCoordinates = async () => {
    if (selectedMatches.length > 0 && firstHullPlayer !== 0) {
      try {
        startLoading();
        const response: ApiResponse<IDefensiveHullData> = await postData(
          apiUrls["GetDefensiveActionEventsData"],
          {
            matchId: selectedMatches[0],
            teamId: selectedFilters.homeTeam,
            playerId: firstHullPlayer,
            listMatchId: selectedMatches,
          }
        );
        setPlayerCoordinates(response.data.eventsPositions);
        setInnerCoordinates(response.data.innerEventsPositions);
        setPlayerAvgPosition(response.data.averagePosition);
        // @ts-ignore
        if (response.data.length === 0) {
          setPopupMessage("No match data available for the selected teams.");
        }
      } catch (error) {
        console.error("Error fetching match list:", error);
        setPopupMessage("Error fetching match list.");
        stopLoading();
      }
    } else {
      stopLoading();
      setPlayerCoordinates([]);
      setInnerCoordinates([]);
      setPlayerAvgPosition({
        location_X: 0,
        location_Y: 0,
      });
    }
  };
  const fetchSecondPlayerCoordinates = async () => {
    if (selectedMatches.length > 0 && secondHullPlayer !== 0) {
      try {
        startLoading();
        const response: ApiResponse<IDefensiveHullData> = await postData(
          apiUrls["GetDefensiveActionEventsData"],
          {
            matchId: selectedMatches[0],
            teamId: selectedFilters.homeTeam,
            playerId: secondHullPlayer,
            listMatchId: selectedMatches,
          }
        );
        setSecondPlayerCoordinates(response.data.eventsPositions);
        setSecondInnerCoordinates(response.data.innerEventsPositions);
        setSecondPlayerAvgPosition(response.data.averagePosition);
        // @ts-ignore
        if (response.data.length === 0) {
          setPopupMessage("No match data available for the selected teams.");
        }
      } catch (error) {
        console.error("Error fetching match list:", error);
        setPopupMessage("Error fetching match list.");
        stopLoading();
      }
    } else {
      stopLoading();
      setSecondPlayerCoordinates([]);
      setSecondInnerCoordinates([]);
      setSecondPlayerAvgPosition({
        location_X: 0,
        location_Y: 0,
      });
    }
  };
  const fetchPassingNetworkData = async (teamId: string, matchId: number) => {
    if (teamId !== "" && matchId !== 0) {
      try {
        startLoading();
        setPlayedTeam("");
        const requestParameters = {
          matchId: matchId,
          teamId: teamId,
          thresholdValue: 10,
          isFinalThird: selectedFilters.isSelectFinalThird,
        };
        const response: ApiResponse<IPassingNetworkData> = await postData(
          apiUrls.GetPassingNetworkData,
          requestParameters
        );
        handleApiResponse(
          response,
          (passingNetworkData) => {
            stopLoading();
            // if (
            //   passingNetworkData.passNetworkPlayerPasses !== null &&
            //   passingNetworkData.passNetworkPlayers !== null
            // ) {
            // stopLoading();
            setPassNetworkPlayers(
              passingNetworkData.passNetworkPlayerPasses !== null
                ? passingNetworkData.passNetworkPlayers
                : []
            );
            setPassNetworkPlayerPasses(
              passingNetworkData.passNetworkPlayers !== null
                ? passingNetworkData.passNetworkPlayerPasses
                : []
            );
            setHomeTeamName(passingNetworkData.homeTeamName);
            setAwayTeamName(passingNetworkData.awayTeamName);
            setHomeTeamScore(Number(passingNetworkData.homeTeamScore));
            setAwayTeamScore(Number(passingNetworkData.awayTeamScore));
            if (teamId === passingNetworkData.homeTeamId) setPlayedTeam("home");
            else setPlayedTeam("away");
            const myDate = new Date(passingNetworkData.matchDate);
            const month = myDate.toLocaleString("default", {
              month: "short",
            });
            const year = myDate.getFullYear();
            const formattedDate = `${month}-${year}`;
            setMatchDate(formattedDate);
            fetchEventsTimeLineData(selectedFilters.homeTeam, selectedMatchId);
            // } else {
            //   stopLoading();
            //   setPassNetworkPlayers([]);
            //   setPassNetworkPlayerPasses([]);
            // }
          },
          (error) => {
            // Handle error
            stopLoading();
            setPassNetworkPlayers([]);
            setPassNetworkPlayerPasses([]);
            console.error("Error fetching passing network data:", error);
          }
        );
      } catch (error: any) {
        stopLoading();
        console.error("Error fetching passing network data:", error);
      }
    } else {
      setPassNetworkPlayers([]);
      setPassNetworkPlayerPasses([]);
    }
  };
  const fetchAvgPositionPlayers = async (teamId: string, matchId: number) => {
    if (teamId !== "" && matchId !== 0) {
      try {
        startLoading();
        setPlayedTeam("");
        const requestParameters = {
          matchId: matchId,
          teamId: teamId,
        };
        const response: ApiResponse<IPlayerForVoronoi[]> = await postData(
          apiUrls.GetAveragePlayerPositionsByTeamMatch,
          requestParameters
        );
        handleApiResponse(
          response,
          (avgPositionPlayersData) => {
            stopLoading();
            if (avgPositionPlayersData.length > 0) {
              // stopLoading();
              setAvgPositionPlayers(avgPositionPlayersData);
            } else {
              stopLoading();
              setAvgPositionPlayers([]);
            }
          },
          (error) => {
            // Handle error
            stopLoading();
            console.error("Error fetching passing network data:", error);
          }
        );
      } catch (error: any) {
        stopLoading();
        console.error("Error fetching passing network data:", error);
      }
    } else {
      setPassNetworkPlayers([]);
      setPassNetworkPlayerPasses([]);
    }
  };
  const fetchEventsTimeLineData = async (teamId: string, matchId: number) => {
    if (teamId !== "" && matchId !== 0) {
      try {
        startLoading();
        const requestParameters = {
          // userId: 1,
          teamId: teamId,
          matchId: matchId,
        };
        const response: ApiResponse<any[]> = await postData(
          apiUrls["GetMatchEventsDataToPlot"],
          requestParameters
        );
        handleApiResponse(
          response,
          (eventData) => {
            stopLoading();
            const lastEvent = eventData[eventData.length - 1];
            const endTimeInSeconds = lastEvent.minute * 60 + lastEvent.seconds;
            setMatchEndTime(endTimeInSeconds);
            // const last = data[data.length - 1];
            // setMatchEndTime(last.minute);
            setEventData(eventData);
          },
          (error) => {
            // Handle error
            stopLoading();
            console.error("Error fetching event list:", error);
          }
        );
      } catch (error) {
        stopLoading();
        console.error("Error fetching event list:", error);
      }
    } else {
      setMatchEndTime(0);
      setEventData([]);
    }
  };
  const fetchPlayerData = async (teamId: string, matchId: number) => {
    if (teamId !== "" && matchId !== 0) {
      try {
        startLoading();
        const requestParameters = {
          teamId: teamId,
          matchId: matchId,
        };
        //const data: any[] = await postData(apiUrls['GetPlayersByTeamMatch'], requestParameters)
        const response: ApiResponse<any[]> = await postData(
          apiUrls["GetPlayersByTeamMatch"],
          requestParameters
        );
        handleApiResponse(
          response,
          (data) => {
            if (data.length > 0) {
              stopLoading();
              setPlayerData(data);
              setPlayerAttackPassData([]);
              handleFilterChange("isShowHeatMap", false);
              handleFilterChange("isShowDefensiveHull", false);
            } else {
              stopLoading();
              setPlayerAttackPassData([]);
              handleFilterChange("isShowHeatMap", false);
              handleFilterChange("isShowDefensiveHull", false);
            }
          },
          (error) => {
            // Handle error
            stopLoading();
            console.error("Error fetching Home Team Data:", error);
          }
        );
      } catch (error) {
        stopLoading();
        console.error("Error fetching event list:", error);
      }
    } else {
      setPlayerData([]);
      setPlayerAttackPassData([]);
    }
  };
  const fetchPlayerAttackPassData = async (
    matchId: number,
    playerId: string
  ) => {
    if (playerId !== "" && matchId !== 0) {
      try {
        startLoading();
        const requestParameters = {
          matchId: matchId,
          playerId: playerId,
        };
        const response: ApiResponse<any[]> = await postData(
          apiUrls["GetPlayerAttackPassData"],
          requestParameters
        );
        handleApiResponse(
          response,
          (data) => {
            if (data.length > 0) {
              stopLoading();
              setPlayerAttackPassData(data);
            } else {
              stopLoading();
              setPlayerAttackPassData([]);
              setPopupMessage(
                "No passing attack data available for the selected player."
              );
              setOpenPopup(true);
            }
          },
          (error) => {
            // Handle error
            stopLoading();
            console.error("Error fetching Home Team Data:", error);
          }
        );
      } catch (error) {
        stopLoading();
        console.error("Error fetching PlayerAttackPassData list:", error);
      }
    } else {
      setPlayerAttackPassData([]);
    }
  };

  const handlePlayerChangeLeft = (event: any) => {
    const { value } = event.target;
    handleFilterChange("selectedPlayerIdLeft", value);
  };
  const handlePlayerChangeRight = (event: any) => {
    const { value } = event.target;
    handleFilterChange("selectedPlayerIdRight", value);
  };
  const changeFirstHullPlayer = (event: any) => {
    const { value } = event.target;
    const selectedPlayer = hullPlayers.filter(
      (player) => player.value === value
    );
    setFirstPlayerName(selectedPlayer[0].label);
    setFirstHullPlayer(value);
  };
  const changeSecondHullPlayer = (event: any) => {
    const { value } = event.target;
    const selectedPlayer = hullPlayers.filter(
      (player) => player.value === value
    );
    setSecondPlayerName(selectedPlayer[0].label);
    setSecondHullPlayer(value);
  };

  const clearData = () => {
    setMatchList([]);
    setEventData([]);
    setPlayerData([]);
    setPlayerAttackPassData([]);
    setRiskMapData([]);
    setHullPlayers([])
    setPlayerAvgPosition({location_X : 0, location_Y : 0})
    setSecondPlayerAvgPosition({location_X : 0, location_Y : 0})
    setSecondHullPlayer(0)
    setFirstHullPlayer(0)
    setPlayerCoordinates([])
    setSecondPlayerCoordinates([])
    setInnerCoordinates([])
    setSecondInnerCoordinates([])
    handleFilterChange("selectedPlayerIdLeft", "");
    handleFilterChange("selectedPlayerIdRight", "");
    handleFilterChange("isDisplayPlayer", false);
    handleFilterChange("isDisplayPassingNetwork", false);
    handleFilterChange("isVoronoiOfPlayers ", false);
    handleFilterChange("isShowHeatMap", false);
    handleFilterChange("isShowRiskMap", false);
    handleFilterChange("isShowDefensiveHull", false);
  };

  useEffect(() => {
    const fetchMatchList = async () => {
      if (
        selectedFilters.selectedOption !== "LAST MATCH" &&
        selectedFilters.homeTeam !== ""
      ) {
        try {
          setHomeTeamName("");
          setAwayTeamName("");
          setHomeTeamScore(0);
          setAwayTeamScore(0);
          clearData();
          startLoading();

          const AllFilterRequestForMatches = {
            // userId: 1,
            teamId: selectedFilters.homeTeam,
            isCurrentSeason:
              selectedFilters.selectedOption === "THIS SEASON" ? true : false,
            matchHomeAway: selectedFilters.matchLabel,
            matchWonLost: selectedFilters.matchStatus,
            isAllOpposition:
              selectedFilters.selectedOppositionTeamId === "All" ? true : false,
            oppositionTeamId:
              selectedFilters.selectedOppositionTeamId === "All"
                ? 0
                : selectedFilters.selectedOppositionTeamId,
            competitionId: selectedFilters.competitionId
              ? selectedFilters.competitionId
              : 0,
            seasonId: selectedFilters.seasonId ? selectedFilters.seasonId : 0,
          };
          const response: ApiResponse<any[]> = await postData(
            apiUrls.GetAllFilteredMatches,
            AllFilterRequestForMatches
          );
          handleApiResponse(
            response,
            (matchData) => {
              stopLoading();
              setMatchList(matchData);
              const filteredMatches = matchData
                .slice(0, 3)
                .map((match: any) => match.matchId);
              // @ts-ignore
              setSelectedMatches(filteredMatches);
              setValue([0, 2]);
              setGroupIndex(0);
            },
            (error) => {
              // Handle error
              stopLoading();
              setPopupMessage(
                "The selected matches you are looking for could not be found."
              );
              setOpenPopup(true);
              console.error(
                "The selected matches you are looking for could not be found.",
                error
              );
            }
          );
        } catch (error: any) {
          stopLoading();
          console.error("Error fetching match list:", error);
        }
      } else {
        setMatchList([]);
      }
    };
    fetchMatchList();
  }, [
    selectedFilters.selectedOption,
    selectedFilters.homeTeam,
    selectedFilters.matchLabel,
    selectedFilters.matchStatus,
    selectedFilters.selectedOppositionTeamId,
    selectedFilters.seasonId,
  ]);

  useEffect(() => {
    const fetchLastMatchInformation = async () => {
      if (
        selectedFilters.selectedOption === "LAST MATCH" &&
        selectedFilters.homeTeam !== ""
      ) {
        try {
          startLoading();
          const response: ApiResponse<LastMatchdata> = await fetchData(
            `${apiUrls.GetUsersLastMatch}?userId=1&UserTeamId=${selectedFilters.homeTeam}`
          );
          handleApiResponse(
            response,
            (lastMatchdata) => {
              stopLoading();
              setHomeTeamName(lastMatchdata.homeTeamName);
              setAwayTeamName(lastMatchdata.awayTeamName);
              setHomeTeamScore(lastMatchdata.homeTeamScore);
              setAwayTeamScore(lastMatchdata.awayTeamScore);
              setSelectedMatchId(Number(lastMatchdata.matchId));
              const myDate = new Date(lastMatchdata.matchDate);
              const month = myDate.toLocaleString("default", {
                month: "short",
              });
              const year = myDate.getFullYear();
              const formattedDate = `${month}-${year}`;
              setMatchDate(formattedDate);
              clearData();
            },
            (error) => {
              // Handle error
              stopLoading();
              console.error("Error fetching Last Match Data:", error);
            }
          );
        } catch (error: any) {
          console.error("Error fetching match list:", error);
          stopLoading();
        }
      } else {
        setHomeTeamName("");
        setAwayTeamName("");
        setHomeTeamScore(0);
        setAwayTeamScore(0);
        setMatchDate("");
        setRiskMapData([]);
      }
    };
    fetchLastMatchInformation();
  }, [selectedFilters.selectedOption, selectedFilters.homeTeam]);

  useEffect(() => {
    if (selectedMatchId) {
      handleFilterChange("selectedPlayerIdLeft", "");
      handleFilterChange("selectedPlayerIdRight", "");
      // Fetch data when selectedMatchId changes
      if (
        selectedFilters.isSelectFinalThird === previousFinalThirdValue.current
      ) {
        fetchPassingNetworkData(selectedFilters.homeTeam, selectedMatchId);
        //fetchEventsTimeLineData(selectedFilters.homeTeam, selectedMatchId);
        fetchPlayerData(selectedFilters.homeTeam, selectedMatchId);
      } else {
        fetchPassingNetworkData(selectedFilters.homeTeam, selectedMatchId);
      }
      fetchAvgPositionPlayers(selectedFilters.homeTeam, selectedMatchId);
      // Update the ref to track previous value of selectedFilters.isSelectFinalThird
      previousFinalThirdValue.current = selectedFilters.isSelectFinalThird;
    }
  }, [
    selectedMatchId,
    selectedFilters.homeTeam,
    selectedFilters.isSelectFinalThird,
  ]);

  useEffect(() => {
    if (selectedFilters.isShowHeatMap) {
      handleFilterChange("isShowRiskMap", false);
      handleFilterChange("isShowDefensiveHull", false);
      fetchPlayerAttackPassData(
        selectedMatchId,
        isPlayerSwitchToggled
          ? selectedFilters.selectedPlayerIdRight
          : selectedFilters.selectedPlayerIdLeft
      );
    }
  }, [
    selectedFilters.isShowHeatMap,
    selectedFilters.selectedPlayerIdLeft,
    selectedFilters.selectedPlayerIdRight,
    isPlayerSwitchToggled,
  ]);

  const handleSwitchClick = (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => {
    event.stopPropagation();
    setIsPlayerSwitchToggled(!isPlayerSwitchToggled);
    if (isPlayerSwitchToggled) {
      handleFilterChange(
        "selectedPlayerIdLeft",
        selectedFilters.selectedPlayerIdLeft
      );
    } else {
      handleFilterChange(
        "selectedPlayerIdRight",
        selectedFilters.selectedPlayerIdRight
      );
    }
  };

  useEffect(() => {
    const fetchRiskMapData = async () => {
      if (selectedFilters.homeTeam && selectedFilters.isShowRiskMap) {
        try {
          handleFilterChange("isShowHeatMap", false);
          handleFilterChange("isShowDefensiveHull", false);
          startLoading();
          const requestParameters = {
            teamId: selectedFilters.homeTeam,
            seasonId: selectedFilters.seasonId ? selectedFilters.seasonId : 0,
            competitionId: selectedFilters.competitionId
              ? selectedFilters.competitionId
              : 0,
          };
          const response: ApiResponse<any[]> = await postData(
            apiUrls["GetRiskMapEventsData"],
            requestParameters
          );
          handleApiResponse(
            response,
            (data) => {
              if (data.length > 0) {
                stopLoading();
                setRiskMapData(data);
              } else {
                stopLoading();
                setRiskMapData([]);
              }
            },
            (error) => {
              // Handle error
              stopLoading();
              console.error("Error fetching Risk Map Data:", error);
            }
          );
        } catch (error: any) {
          console.error("Error fetching risk map data:", error);
          stopLoading();
        }
      } else {
        setRiskMapData([]);
      }
    };

    fetchRiskMapData();
  }, [selectedFilters.isShowRiskMap]);

  useEffect(() => {
    if (selectedFilters.isShowDefensiveHull) {
      handleFilterChange("isShowRiskMap", false);
      handleFilterChange("isShowHeatMap", false);
    }
  }, [selectedFilters.isShowDefensiveHull]);

  return (
    <MainContainer
      active={props.toggle}
      isSubSidebarOpen={props.isSubSidebarOpen}
      className="main-container"
    >
      {loading && <LoadingSpinner />}
      <Drawer
        PaperProps={{
          style: {
            left: "100px",
            backgroundColor: "#000",
          },
        }}
        anchor="left"
        variant="persistent"
        open={sidebarOpen}
        onClose={() => {
          setSidebarOpen(!sidebarOpen);
        }}
      >
        <MatchSelection
          onCloseDrawer={() => {
            setSidebarOpen(false);
          }}
          onFilterChange={handleFilterChange}
          selectedFilters={selectedFilters}
        />
      </Drawer>
      <Drawer
        PaperProps={{
          style: {
            left: "100px",
            background: "#111111",
          },
        }}
        anchor="left"
        variant="persistent"
        open={playerSidebarOpen}
        onClose={() => {
          setPlayerSidebarOpen(!playerSidebarOpen);
        }}
      >
        <Players
          onCloseDrawer={() => {
            setPlayerSidebarOpen(false);
          }}
          onFilterChange={handleFilterChange}
          selectedFilters={selectedFilters}
        />
      </Drawer>
      {/* <PageHeader username='PETE' 
      logInTeam='https://cdn5.wyscout.com/photos/team/public/786_120x120.png'/> */}
      <div className="main-right-bar">
        <div className="logo-header">
          <img
            src="https://cdn5.wyscout.com/photos/team/public/786_120x120.png"
            alt="Icon"
          />
          <h1>WELCOME, PETE</h1>
        </div>

        <div className="report-header">
          <div className="report-left">
            <CustomButton
              endIcon={<KeyboardArrowDownIcon />}
              color="primary"
              onClick={() => {
                setSidebarOpen(!sidebarOpen);
              }}
            >
              {selectedFilters.selectedOption}
            </CustomButton>
            <span>{matchDate}</span>
          </div>

          <div className="report-center">
            <span>{homeTeamName}</span>
            <ul>
              <li>{homeTeamScore}</li>
              <li>{awayTeamScore}</li>
            </ul>
            <span>{awayTeamName}</span>
          </div>

          <div className="report-right">
            <CustomButton
              startIcon={
                <img
                  src={GeneralReportIcon}
                  alt="Generate Report"
                  width="24"
                  height="24"
                />
              }
            >
              GENERATE REPORT
            </CustomButton>

            <div className="report-right-icon">
              <FullscreenIcon />
              <MoreVertIcon />
            </div>
          </div>
        </div>

        <div className="team-tracking">
          <MatchTrack
            matches={displayedMatches}
            onSelectMatchId={handleSelectedMatchId}
          />
          {/* <MatchTrackD3/> */}
        </div>
        {eventData.length > 0 && (
          <div className="team-tracking-player">
            <EventTrack
              events={eventData}
              endTime={matchEndTime}
              playedTeam={playedTeam}
            />
          </div>
        )}
        <div className="match-play">
          <CustomIconButton onClick={() => handleNextGroup()}>
            <KeyboardArrowLeftIcon fontSize="large" />
          </CustomIconButton>
          <CustomIconButton onClick={() => handlePreviousGroup()}>
            <KeyboardArrowRightIcon fontSize="large" />
          </CustomIconButton>
        </div>
        <div className="match-set"></div>
        <div className="pitch-wapper-main">
          <div className="pitch-wapper">
            {!selectedFilters.isShowDefensiveHull && (
              <div className="select-wrapper">
                <div className="all-leeds-players">
                  <SelectDropdown
                    label="ALL PLAYERS"
                    options={playerData}
                    value={selectedFilters.selectedPlayerIdLeft}
                    onChange={handlePlayerChangeLeft}
                    multiple={false} // Set to false for single selection
                    selectAllOption={false} // Optionally show "Select All" option
                  />
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "20px" }}
                >
                  <h4 style={{ color: "white" }}>
                    Compare Player Passing Attack{" "}
                  </h4>
                  <Switch
                    id="player-switch"
                    toggled={isPlayerSwitchToggled}
                    onChange={handleSwitchClick}
                    source='Sidebar' isByComparison={false}
                  />
                </div>
                <div className="all-leeds-players">
                  <SelectDropdown
                    label="ALL PLAYERS"
                    options={playerData}
                    value={selectedFilters.selectedPlayerIdRight}
                    onChange={handlePlayerChangeRight}
                    multiple={false} // Set to false for single selection
                    selectAllOption={false} // Optionally show "Select All" option
                  />
                </div>
              </div>
            )}
            {selectedFilters.isShowDefensiveHull && (
              <div>
                <div className="tab-nav" style={containerStyle}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      minWidth: "101%",
                      marginTop: "20px",
                      marginLeft: "-5px",
                    }}
                  >
                    {matchList?.map((match) => (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          cursor: "pointer",
                          position: "relative",
                        }}
                        key={match.matchId}
                        onMouseEnter={() => setHoverMatchId(match.matchId)}
                        onMouseLeave={() => setHoverMatchId(0)}
                      >
                        <span
                          style={{
                            fontSize: "xx-small",
                            textAlign: "center",
                            width: "90px",
                            display:
                              hoverMatchId === match.matchId ? "block" : "none",
                            transition: "opacity 0.2s ease-in-out",
                            position: "absolute",
                            top: "-20px",
                            color: "white",
                          }}
                        >
                          {match.matchLabel}
                        </span>
                        <img
                          src={match.teamLogoURL}
                          style={{ width: "14px", height: "14px" }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <div className="tab-nav" style={containerStyle}>
                  {matchList?.length > 0 && (
                    <CustomSlider
                      slots={{ thumb: ThumbComponent }}
                      value={value}
                      min={0}
                      max={matchList?.length - 1}
                      onChange={handleChange}
                      // @ts-ignore
                      steps={matchList?.length - 1}
                      marks={true}
                    />
                  )}
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "20px",
                    marginTop: "10px",
                  }}
                >
                  <div
                    className="all-leeds-players"
                    style={{ minWidth: "260px" }}
                  >
                    <HullSelectDropdown
                      label="CHOOSE FIRST PLAYER"
                      options={hullPlayers}
                      value={firstHullPlayer}
                      onChange={changeFirstHullPlayer}
                      multiple={false}
                      selectAllOption={false}
                    />
                  </div>
                  <div
                    className="all-leeds-players"
                    style={{ minWidth: "290px" }}
                  >
                    <HullSelectDropdown
                      label="CHOOSE SECOND PLAYER"
                      options={hullPlayers}
                      value={secondHullPlayer}
                      onChange={changeSecondHullPlayer}
                      multiple={false}
                      selectAllOption={false}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="pitch-code-start">
              <div className="pitch-left-option">
                <CustomIconButton
                  className={
                    selectedFilters.isDisplayPlayer
                      ? "selectedButton"
                      : "unselectedButton"
                  }
                  onClick={() => {
                    handleFilterChange(
                      "isDisplayPlayer",
                      !selectedFilters.isDisplayPlayer
                    );
                  }}
                  title="Player Average Positions"
                >
                  <img
                    src={DisplayPlayer}
                    alt="DisplayPlayer"
                    width="24"
                    height="24"
                  />
                </CustomIconButton>

                <CustomIconButton
                  className={"unselectedButton"}
                  //onClick={() => { handleFilterChange('isDisplayPlayer', !selectedFilters.isDisplayPlayer) }}
                >
                  <img src={ContourIcon} alt="ContourIcon" />
                </CustomIconButton>

                <CustomIconButton
                  className={
                    selectedFilters.isDisplayPassingNetwork
                      ? "selectedButton"
                      : "unselectedButton"
                  }
                  onClick={() => {
                    handleFilterChange(
                      "isDisplayPassingNetwork",
                      !selectedFilters.isDisplayPassingNetwork
                    );
                  }}
                  title="Passing Network"
                >
                  <img
                    loading="lazy"
                    src={PassingNetworkIcon}
                    alt="PassingNetworkIcon"
                  />
                </CustomIconButton>

                <CustomIconButton
                  className={
                    selectedFilters.isShowHeatMap
                      ? "selectedButton"
                      : "unselectedButton"
                  }
                  onClick={() => {
                    handleFilterChange(
                      "isShowHeatMap",
                      !selectedFilters.isShowHeatMap
                    );
                  }}
                  title="Passing Attack"
                >
                  <img
                    loading="lazy"
                    src={PassingAttackIcon}
                    alt="PassingAttackIcon"
                  />
                </CustomIconButton>
                <CustomIconButton
                  className={
                    selectedFilters.isVoronoiOfPlayers
                      ? "selectedButton"
                      : "unselectedButton"
                  }
                  onClick={() => {
                    handleFilterChange(
                      "isVoronoiOfPlayers",
                      !selectedFilters.isVoronoiOfPlayers
                    );
                  }}
                  title="Voronoi Diagram"
                >
                  <img loading="lazy" src={VoronoiIcon} alt="VoronoiIcon" />
                </CustomIconButton>

                <CustomIconButton
                  className={
                    selectedFilters.isShowRiskMap
                      ? "selectedButton"
                      : "unselectedButton"
                  }
                  onClick={() => {
                    handleFilterChange(
                      "isShowRiskMap",
                      !selectedFilters.isShowRiskMap
                    );
                  }}
                  title="Risk Map"
                >
                  <img loading="lazy" src={RiskMapIcon} alt="RiskMapIcon" />
                </CustomIconButton>

                <CustomIconButton
                  className={
                    selectedFilters.isShowDefensiveHull
                      ? "selectedButton"
                      : "unselectedButton"
                  }
                  onClick={() => {
                    handleFilterChange(
                      "isShowDefensiveHull",
                      !selectedFilters.isShowDefensiveHull
                    );
                  }}
                  title="Defensive Action Hull"
                >
                  <img
                    loading="lazy"
                    src={DefensiveHullIcon}
                    alt="DefensiveHullIcon"
                  />
                </CustomIconButton>

               
              </div>

              {/* Pitch Component on a new line */}

              <DrawPitch
                //onDataFetch={[]}
                selectedFilters={selectedFilters}
                passNetworkPlayers={passNetworkPlayers}
                avgPositionPlayers={avgPositionPlayers}
                passNetworkPlayerPasses={passNetworkPlayerPasses}
                playerAttackPassData={playerAttackPassData}
                riskMapData={riskMapData}
                defensiveHullData={{
                  firstHullPlayerCoord: playerCoordinates,
                  secondHullPlayerCoord: secondPlayerCoordinates,
                  firstHullPlayerInner: innerCoordinates,
                  secondHullPlayerInner: secondInnerCoordinates,
                  firstPlayerPosition: playerAvgPosition,
                  secondPlayerPosition: secondPlayerAvgPosition,
                  firstPlayerName: firstPlayerName,
                  secondPlayerName: secondPlayerName,
                }}
              />
              {selectedFilters.isModalOpen ? (
                <PitchOptions
                  isOpen={selectedFilters.isModalOpen}
                  selectedPitchOption={selectedFilters.selectedPitchOption}
                  onClose={handleCloseModal}
                />
              ) : null}

              <div className="pitch-right-option">
                <CustomIconButton className={"unselectedButton"}>
                  <img loading="lazy" src={PitchIcon} alt="PitchIcon" />
                </CustomIconButton>

                <CustomIconButton className={"unselectedButton"}>
                  <img src={perspective} alt="perspective" />
                </CustomIconButton>

                {/* <ArrowBackIosIcon sx={{ color: 'white' }} /> */}

                <CustomIconButton
                  className={"unselectedButton"}
                  onClick={() => {
                    handleFilterChange("isModalOpen", true);
                  }}
                >
                  <img src={Pitch} alt="Pitch" />
                </CustomIconButton>
              </div>
            </div>
          </div>
        </div>
      </div>
      {renderMessagePopup()}
    </MainContainer>
  );
};

export default Home;
